import { OrderErrorCode } from './OrderErrorCode';
export class PaymentFailedCardError extends Error {
    constructor(message, amount) {
        super(message);
        this.amount = amount;
        this.code = OrderErrorCode.PaymentFailedCardError;
        Object.setPrototypeOf(this, PaymentFailedCardError.prototype);
    }
}
export function isPaymentFailedCardError(error) {
    return (typeof error.code !== 'undefined' &&
        error.code === OrderErrorCode.PaymentFailedCardError);
}
